import { useState } from "react";
import { PERSONAS } from "@/data/canvas";
import { usePersona } from "@/context/PersonaContext";
import { ChevronDown, Users } from "lucide-react";

export function PersonaSwitcher() {
  const { personaId, setPersonaId, persona } = usePersona();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative" data-testid="persona-switcher">
      <button
        data-testid="persona-switcher-trigger"
        onClick={() => setOpen((o) => !o)}
        className="group flex items-center gap-3 rounded-full border border-stone-200/70 bg-white/80 py-1.5 pl-1.5 pr-3 shadow-[0_8px_32px_rgba(0,0,0,0.08)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-0.5"
      >
        <img src={persona.avatar} alt={persona.name} className="h-9 w-9 rounded-full object-cover" />
        <span className="hidden text-left sm:block">
          <span className="block text-sm font-semibold leading-tight text-mill-ink">{persona.name}</span>
          <span className="block text-xs leading-tight text-mill-muted">{persona.role}</span>
        </span>
        <ChevronDown className={`h-4 w-4 text-mill-muted transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            data-testid="persona-switcher-menu"
            className="absolute right-0 z-50 mt-2 w-80 origin-top-right animate-fade-up rounded-2xl border border-stone-200 bg-white p-2 shadow-xl"
          >
            <div className="flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-[0.16em] text-mill-muted">
              <Users className="h-3.5 w-3.5" /> View the canvas as…
            </div>
            {PERSONAS.map((p) => {
              const active = p.id === personaId;
              return (
                <button
                  key={p.id}
                  data-testid={`persona-switch-${p.id}`}
                  onClick={() => { setPersonaId(p.id); setOpen(false); }}
                  className={`flex w-full items-start gap-3 rounded-xl p-2.5 text-left transition-colors ${active ? "bg-mill-moss text-white" : "hover:bg-mill-alt"}`}
                >
                  <img src={p.avatar} alt={p.name} className="h-10 w-10 shrink-0 rounded-full object-cover" />
                  <span className="min-w-0">
                    <span className={`block text-sm font-semibold ${active ? "text-white" : "text-mill-ink"}`}>{p.name}</span>
                    <span className={`block text-xs font-medium ${active ? "text-white/80" : "text-mill-moss"}`}>{p.role}</span>
                    <span className={`mt-0.5 block text-xs leading-snug ${active ? "text-white/70" : "text-mill-muted"}`}>{p.authority}</span>
                  </span>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
